import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../index";
import type { PoolTournamentState } from "@/shared/types";

interface PoolTournamentStoreState {
  tournamentState: PoolTournamentState | null;
  error: string | null;
  lastUpdatedAt: number | null;
}

const initialState: PoolTournamentStoreState = {
  tournamentState: null,
  error: null,
  lastUpdatedAt: null
};

const poolTournamentSlice = createSlice({
  name: "poolTournament",
  initialState,
  reducers: {
    poolTournamentStateReceived: (state, action: PayloadAction<PoolTournamentState>) => {
      const incoming = action.payload;
      if (!state.tournamentState || incoming.version >= state.tournamentState.version) {
        state.tournamentState = incoming;
        state.error = null;
        state.lastUpdatedAt = Date.now();
      }
    },
    poolTournamentStateHydrated: (state, action: PayloadAction<PoolTournamentState>) => {
      state.tournamentState = action.payload;
      state.error = null;
      state.lastUpdatedAt = Date.now();
    },
    poolTournamentCommandRejected: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.lastUpdatedAt = Date.now();
    },
    clearPoolTournamentState: () => initialState
  }
});

export const {
  poolTournamentStateReceived,
  poolTournamentStateHydrated,
  poolTournamentCommandRejected,
  clearPoolTournamentState
} = poolTournamentSlice.actions;

export const selectPoolTournamentState = (state: RootState) => state.poolTournament.tournamentState;
export const selectPoolTournamentError = (state: RootState) => state.poolTournament.error;
export const selectPoolTournamentLastUpdatedAt = (state: RootState) => state.poolTournament.lastUpdatedAt;

export default poolTournamentSlice.reducer;

